// extracted by mini-css-extract-plugin
export var wrapper = "Sitetop-module--wrapper--2I1tq";
export var logo = "Sitetop-module--logo--3OXqy";
export var searchWrapper = "Sitetop-module--search-wrapper--2DFTJ";
export var bordered = "Sitetop-module--bordered--2KXNX";